const KEY_MENU = "Tech.Menu.";
const MENU_KEY_EXPIRY = 60 * 60 * 1000; //ms
var selectedCountryCode = $('html').data('selected-country-code');

var mobileWrap = $('#faculties-menu-mobile-wrapper')
var textStart = mobileWrap.data('text-start')
var textAllAbout = mobileWrap.data('text-all-about')


export function loadMenu(menuMode, ref) {
    var lang = $('body').data().languageCode;
    var key = KEY_MENU + selectedCountryCode + '.' + lang;
    let request = indexedDB.open("techMenu", 1);
    let IDBVersion = "1.2";
    var geoCountry = tech.core.getCookie('userCountryCode')
    request.onupgradeneeded = function(event) {
        let db = event.target.result;
        if (!db.objectStoreNames.contains("menu")) {
            db.createObjectStore("menu", {keyPath: "id"});
        }
    }
    request.onsuccess = function(event) {
        let db = event.target.result;
        
        let transaction = db.transaction("menu", "readonly");
        let store = transaction.objectStore("menu");
        
        let countRequest = store.count();
        let expireDate = Date.now() + 43200000; //12 Hours on milliseconds
        countRequest.onsuccess = function(event) {
            if (countRequest.result > 0) {                
                let getTransaction = db.transaction(["menu"], "readonly");
                let store = getTransaction.objectStore("menu");
                let getRequest = store.get(1);
                
                
                getRequest.onsuccess = function(event) {
                    let menuLang = getRequest.result.lang;
                    let menuExpDate = getRequest.result.expDate; 
                    let menuVersion = getRequest.result.dbVersion;
                    let menuCountry = getRequest.result.menuCountryCode;
                    if (menuLang === lang && expireDate > menuExpDate && IDBVersion === menuVersion && menuCountry === selectedCountryCode) {
                        console.log("Getting menu from IDB");
                        let dataDB = getRequest.result.menu;
                        menu = dataDB;
                        buildStudiesMenu(menu);
                        loadDataMenu = true;
                        afterMenuLoad(menuMode, ref);
                    } else {
                        console.log("Getting menu from CF/API");
                        $.ajax({
                            type: 'GET',
                            url: tech.core.getInternationalUrl('/Home/GetMenu'),
                            data: { countryCode: selectedCountryCode, userCountryCode: geoCountry },
                            dataType: 'json'
                        }).done(function(data) {
                            storeMenuIndexDB(menuMode, ref, data, db, lang, expireDate, IDBVersion);
                        });
                    }                    
                }
            } else {
                console.log("Getting menu from CF/API");
                $.ajax({
                    type: 'GET',
                    url: tech.core.getInternationalUrl('/Home/GetMenu'),
                    data: { countryCode: selectedCountryCode, userCountryCode: geoCountry },
                    dataType: 'json'
                }).done(function(data) {
                    storeMenuIndexDB(menuMode, ref, data, db, lang, expireDate, IDBVersion);
                });
            }
        }
    }
    request.onerror = function(event) {
        console.log("Getting menu from CF/API");
        $.ajax({
            type: 'GET',
            url: tech.core.getInternationalUrl('/Home/GetMenu'),
            data: { countryCode: selectedCountryCode, userCountryCode: geoCountry },
            dataType: 'json'
        }).done(function(data) {
            menu = data;
            buildStudiesMenu(menu);
            loadDataMenu = true;
            afterMenuLoad(menuMode, ref);
        });
    }
}


function storeMenuIndexDB(menuMode, ref, data, db, lang, expireDate, IDBVersion) {
    let storeTransaction = db.transaction(["menu"], "readwrite");
    let store = storeTransaction.objectStore("menu");
    store.clear();
    let storeRequest = store.add({id: 1, menu: data, lang: lang, expDate: expireDate, dbVersion: IDBVersion, menuCountryCode: selectedCountryCode});
    menu = data;
    buildStudiesMenu(menu);
    loadDataMenu = true;
    afterMenuLoad(menuMode, ref);
}

function afterMenuLoad(menuMode, ref) {
    if (menuMode == 'desktop') {
        menuBar.removeClass('white-bg-loader');
        $('body').append($('#faculties-menu-desktop-wrapper #loaderBox').hide());
        $("#faculties-menu-desktop-wrapper #tech-navigation").show();
        tech.core.toggleHeaderMenuWrapper(ref);
    } else {
        $('body').append($('#faculties-menu-mobile-wrapper #loaderBox').hide());
        $("#faculties-menu-mobile-wrapper .navbar-nav").show();
    }
}

function cleanMenuFromLocalStorage() {
    var arr = []; // Array to hold the keys
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 10) == 'Tech.Menu.') {
            arr.push(localStorage.key(i));
        }
    }

    // Iterate over arr and remove the items by key
    for (var i = 0; i < arr.length; i++) {
        localStorage.removeItem(arr[i]);
    }
}

function saveToLocalStorage(key, value, ttl) { //ttl: in milliseconds
    const now = new Date()

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl
    }
    localStorage.setItem(key, JSON.stringify(item))
}

function getFromLocalStorage(key) {
    const itemStr = localStorage.getItem(key)
        // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
        // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

function injectAngleRightIcon() {
    return '<svg aria-hidden="true" focusable="false" class="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">\
               <path fill="#FFF" d="M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"></path>\
            </svg>';
}

function injectAngleLeftIcon() {
    return '<svg aria-hidden="true" focusable="false" class="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">\
                <path fill="#dad9d9" d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"></path>\
            </svg>';
}

export function showNextMobileSection(obj, ref, menuType, item, parentItem) {
    if (!loadDataMenu && loadMenuPromise !== undefined) {
        loadMenuPromise.done(() => {
            showMobileSection(obj, ref, menuType, item, parentItem);
        });
    }
    showMobileSection(obj, ref, menuType, item, parentItem);
}

function getSearchButtonMobileText(){
    let searchUrl = "/buscar"
    if (document.getElementById('search-url') !== undefined || document.getElementById('search-url') !== null) {
        searchUrl = document.getElementById('search-url').value;
    }
    return '<li class="nav-item waves-light">\
                <div class="expand-highlight">\
                    <div class="search-wrap">\
                        <span class="left-icon expand-highlight-left-icon"></span>\
                        <form method="get" action="' + searchUrl + '">\
                            <input name="terms" class="search ng-untouched ng-pristine ng-valid" placeholder="'+ $('#faculties-menu-mobile-wrapper').data('search-placeholder')+'" type="text">\
                            <span class="right-icon expand-highlight-right-icon">\
                                <button size="sm" type="submit" class="sidebar-btn-search">\
                                    <svg aria-hidden="true" focusable="false" class="search-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" labelledby="search">\
                                        <title id="search"></title>\
                                        <path fill="#dad9d9" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>\
                                    </svg>\
                                </button>\
                            </span>\
                        </form>\
                    </div>\
                    <div class="border"></div>\
                </div>\
            </li>';
}

export function showMobileSection(obj, ref, menuType, item, parentItem) {
    var target = $(ref);
    var menuBag = null;
    var menuLabel = ''
    if (menuType == "study") {
        menuBag = studiesMenu;
        menuLabel = 'Estudios';
    } else if (menuType == "faculty") {
        menuBag = menu;
        menuLabel = 'Facultades';
    }
    
    if (typeof(parentItem) !== 'undefined' && typeof(item) !== 'undefined') {
        // LEVEL 3
        var parentMenuItem = menuBag[parentItem];

        if (parentMenuItem && parentMenuItem.items.length > 0) {

            var menuItem = parentMenuItem.items[item];

            if (menuItem && menuItem.items.length > 0) {
                var container = $('<div/>')
                var buttonText = getSearchButtonMobileText();
                container.append(buttonText + '\
                    <li class="nav-item waves-light" mdbwaveseffect=""><a class="nav-link selected" onclick="tech.core.mobileMenuGoLevel(0)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + textStart + '</span><span class="right-icon"></span></a></li>\
                    <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link selected area-selected" onclick="tech.core.mobileMenuGoLevel(1)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + menuLabel + '</span><span class="right-icon"></span></a></li>\
                    <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link selected area-selected" onclick="tech.core.mobileMenuGoLevel(2)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + parentMenuItem.label + '</span><span class="right-icon"></span></a></li>\
                    \
                    <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link item waves-light option show-all-options" href="/' + menuItem.url + '"><span class="left-icon"></span><span class="tag">' + textAllAbout + ' ' + menuItem.label + '</span><span class="right-icon"></span></a></li>\
                ');

                for (var i in menuItem.items) {
                    var nextItem = menuItem.items[i];
                    var wrap = $('<li class="nav-item inner-list menu-sidebar-nav-item ng-star-inserted" />');

                    if (nextItem.label != null) {
                        if (nextItem.fullUrl) {
                            wrap.append('<div class="course-type ng-star-inserted"><a class="course-type-label" href="/' + nextItem.fullUrl + '">' + nextItem.label + '</a></div>')
                        } else {
                            wrap.append('<div class="course-type ng-star-inserted"><span class="course-type-label">' + nextItem.label + '</span></div>')
                        }                        
                    }
                    var list = $('<ul class="navbar-nav"/>')
                    if (nextItem.items.length > 0) {
                        for (var j in nextItem.items) {
                            var childItem = nextItem.items[j];
                            list.append('<li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link waves-light" href="/' + childItem.url + '"><span class="left-icon"></span><span class="tag">' + childItem.label + '</span><span class="right-icon"></span></a></li>')
                        }
                    }
                    wrap.append(list);
                    container.append(wrap);
                }
                target.find('ul').html(container.html())
            }
        }
    } else if (typeof(item) !== 'undefined') {

        // LEVEL 2

        var menuItem = menuBag[item];
        if (menuItem && menuItem.items.length > 0) {
            var container = $('<div/>')
            var buttonText = getSearchButtonMobileText();
            container.append(buttonText + '\
                <li class="nav-item waves-light" mdbwaveseffect=""><a class="nav-link selected" onclick="tech.core.mobileMenuGoLevel(0)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + textStart + '</span><span class="right-icon"></span></a></li>\
                <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link selected area-selected" onclick="tech.core.mobileMenuGoLevel(1)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + menuLabel + '</span><span class="right-icon"></span></a></li>');
            if (menuType == "faculty") {
                container.append('\
                        <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect=""><a class="nav-link item waves-light option show-all-options" href="/' + menuItem.url + '"><span class="left-icon"></span><span class="tag">' + textAllAbout + ' ' +  menuItem.label + '</span><span class="right-icon"></span></a></li>');
            }

            for (var i in menuItem.items) {
                var nextItem = menuItem.items[i];
                container.append('\
                <li class="nav-item waves-light ng-star-inserted" mdbwaveseffect="">\
                    <a class="nav-link item waves-light option" onclick="techMenuMobile.loadMenu.showNextMobileSection(this, \'#sb-level3\', \'' + menuType + '\', ' + i + ', ' + item + ')">\
                        <span class="left-icon"></span>\
                        <span class="tag">' + nextItem.label + '</span>\
                        <span class="right-icon">' + injectAngleRightIcon() + '</span>\
                    </a>\
                </li>');
            }
            target.find('ul').html(container.html())
        }
    } else {

        // LEVEL 1

        if (menuBag) {
            var container = $('<div/>')
            var buttonText = getSearchButtonMobileText();
            container.append(buttonText + '\
                <li class="nav-item waves-light" mdbwaveseffect=""><a class="nav-link selected" onclick="tech.core.mobileMenuGoLevel(0)"><span class="left-icon">' + injectAngleLeftIcon() + '</span><span class="tag">' + textStart + '</span><span class="right-icon"></span></a></li>\
            ');
            for (var i in menuBag) {
                var nextItem = menuBag[i];
                container.append('\
                <li class="nav-item waves-light" mdbwaveseffect="">\
                <a class="nav-link item waves-light area" onclick="techMenuMobile.loadMenu.showNextMobileSection(this, \'#sb-level2\', \'' + menuType + '\', ' + i + ')">\
                    <span class="menu-faculty-mobile-wrap ' + (menuType == 'study' ? 'mobile-menu-studies-pad' : '') + '">' + (menuType != "faculty" ? '' : '<svg class="faculty-icon-svg"><use xlink:href="/assets/icon/sprites-faculties.svg#tech-' + nextItem.name.substring(nextItem.name.indexOf('/') + 1) + '"></use></svg>') + '\
                    <span class="tag">' + nextItem.label + '</span></span><span class="right-icon">'+ injectAngleRightIcon() + '</span>\
                </a>\
                </li>');
            }
            target.find('ul').html(container.html())
        }
    }
    //Show
    $(obj).parents('.sidebar').addClass('openNext');
    target.addClass('open');
}

function buildStudiesMenu(menu) {
    var distinctStudies = new Object();
    var distinctFaculties = new Object();
    menu.forEach(faculty => {
        // Taking distinc faculties
        if (!distinctFaculties.hasOwnProperty(faculty.url)) {
            const cloneDistinctFaculty = Object.assign({}, faculty);
            delete cloneDistinctFaculty.items;
            distinctFaculties[faculty.url] = cloneDistinctFaculty;
        }
        faculty.items.forEach(speciality => {
            speciality.items.forEach(study => {
                // Taking distinc studies
                if (!distinctStudies.hasOwnProperty(study.name)) {
                    const cloneDistinctStudy = Object.assign({}, study);
                    delete cloneDistinctStudy.items;
                    distinctStudies[study.name] = cloneDistinctStudy;
                }
                // Check if exist study
                const indexMatchingStudies = studiesMenu.findIndex(s => s.name === study.name);
                if (studiesMenu.length > 0 && indexMatchingStudies > -1) {
                    // Check if exist faculty
                    const indexMatchingFaculty = studiesMenu[indexMatchingStudies].items.findIndex(f => f.name === faculty.name);
                    if (indexMatchingFaculty > -1) {
                        // Add speciality
                        const cloneSpeciality = Object.assign({}, speciality);
                        // Check if exist speciality
                        const indexMatchingSpeciality = studiesMenu[indexMatchingStudies].items[indexMatchingFaculty].items.findIndex(s => s.url === cloneSpeciality.url);

                        if (indexMatchingSpeciality === -1) {
                            cloneSpeciality.fullUrl = study.fullUrl;
                            const indexMatchingStudyInner = cloneSpeciality.items.findIndex(s => s.url === study.url);
                            if (indexMatchingStudyInner > -1) {
                                cloneSpeciality.items = cloneSpeciality.items[indexMatchingStudyInner].items;
                            }
                            studiesMenu[indexMatchingStudies].items[indexMatchingFaculty].items.push(cloneSpeciality);
                        }
                        studiesMenu[indexMatchingStudies].items[indexMatchingFaculty].items.sort(((a, b) => (a.name > b.name) ? 1 : -1));
                    } else {
                        // Add faculty and speciality
                        studiesMenu[indexMatchingStudies].items.push(buildStudyStructure(faculty, speciality, study));
                    }
                } else {
                    //Add study, faculty and speciality
                    const cloneStudy = Object.assign({}, study);
                    cloneStudy.items = [];
                    cloneStudy.items.push(buildStudyStructure(faculty, speciality, study));
                    studiesMenu.push(cloneStudy);
                }
            });
        });
    });
    studiesMenu.sort(((a, b) => (a.order > b.order) ? 1 : -1));
    rebuildFirstLevelMenu(distinctFaculties, distinctStudies);
}

function buildStudyStructure(faculty, speciality, study) {
    let cloneFaculty = Object.assign({}, faculty);
    cloneFaculty.items = [];
    cloneFaculty.url = study.url;

    let cloneSpeciality = Object.assign({}, speciality);
    cloneSpeciality.items = study.items;
    cloneSpeciality.fullUrl = study.fullUrl;

    //const emptyItem = new Object({ "id": null, "name": null, "label": null, "fullLabel": null, "url": null, "icon": null, "order": 0, "weight": 0, "seoData": null, "items": [cloneSpeciality] });
    cloneFaculty.items.push(cloneSpeciality);
    return cloneFaculty;
}

function removeCountryCodeFromUrl(url) {
    if (url.indexOf('/') > -1) {
        return url.split('/')[1]
    }
    return url;
}

function rebuildFirstLevelMenu(menuFaculty, menuStudy) {
    let order = 0;
    let menuElements = [];
    // ObjectToArray and array sort
    Object.keys(menuFaculty).forEach(key => menuElements.push(menuFaculty[key]));
    menuElements.sort(((a, b) => (a.order > b.order) ? 1 : -1));
    // Localize firstLevelMenu and clone anchor model
    let firstLevelMenu = $('.faculty-menu .areas');
    let anchorCopy = $('.faculty-menu .areas .nav-link').first().clone();
    // Remove nav-links and regenerate from array
    $('.faculty-menu .areas .nav-link').remove('.nav-link');
    menuElements.forEach(faculty => {
        $(anchorCopy).attr('data-item', order);
        if (!(window.USER_IS_TOUCHING || false)) {
            $(anchorCopy).attr('href', '/' + faculty.url);
        }
        $(anchorCopy).find('.tag span').html(faculty.label);
        $(anchorCopy).find('use').attr('xlink:href', '/assets/icon/sprites-faculties.svg#tech-' + removeCountryCodeFromUrl(faculty.name));
        $(anchorCopy).clone().appendTo(firstLevelMenu);
        order++;
    });
    order = 0;
    menuElements = [];
    // ObjectToArray and array sort
    Object.keys(menuStudy).forEach(key => menuElements.push(menuStudy[key]));
    menuElements.sort(((a, b) => (a.order > b.order) ? 1 : -1));
    // Localize firstLevelMenu and clone anchor model
    firstLevelMenu = $('.study-menu .areas');
    anchorCopy = $('.study-menu .areas .nav-link').first().clone();
    // Remove nav-links and regenerate from array
    $('.study-menu .areas .nav-link').remove('.nav-link');
    menuElements.forEach(study => {
        $(anchorCopy).attr('data-item', order);
        $(anchorCopy).find('.tag').html(study.label);
        $(anchorCopy).clone().appendTo(firstLevelMenu);
        order++;
    });
}

function executeMenuAnimations(elem, menuRef) {
    if (menu == null) {
        return;
    }

    let parentWrap = elem.parents('.options-parent')
    parentWrap.find('.nav-link.selected').removeClass('selected')
    elem.addClass('selected')

    let menuElem = elem.parents(menuRef);
    let nextPlaceholder = menuElem.eq(0).find('.options');
    let secondPlaceholder = menuElem.eq(0).find('.second-options');
    let item = elem.data('item');
    let parentItem = elem.data('parent-item');

    var isTouch = window.USER_IS_TOUCHING;

    try {

        if (typeof(parentItem) !== 'undefined' && typeof(item) !== 'undefined') {

            let parentMenuItem = (menuRef === '.faculty-menu') ? menu[parentItem] : studiesMenu[parentItem];

            if (parentMenuItem && parentMenuItem.items.length > 0) {

                let menuItem = parentMenuItem.items[item];

                if (menuItem && menuItem.items.length > 0) {
                    let container = $('<div/>')
                    if (isTouch) {
                        container.append('\
                        <div class="second-option margin-top-courses show-all-options ng-star-inserted"><a class="nav-link waves-light" href="/' + menuItem.url + '"><span class="tag">' + textAllAbout + ' ' + menuItem.label + '</span></a></div>');
                    }

                    for (let i in menuItem.items) {
                        let nextItem = menuItem.items[i];
                        let wrap = $('<div class="second-option" />');

                        if (nextItem.label != null) {
                            if (nextItem.fullUrl) {
                                wrap.append('<div class="course-type"><a href="/' + nextItem.fullUrl + '">' + nextItem.label + '</a></div>')
                            } else {
                                wrap.append('<div class="course-type">' + nextItem.label + '</div>')
                            }
                        }

                        if (nextItem.items.length > 0) {
                            for (let j in nextItem.items) {
                                let childItem = nextItem.items[j];
                                wrap.append('<a class="nav-link areas-second-option-nav-link waves-light" href="/' + childItem.url + '">' + childItem.label + '</a>')
                            }
                        }
                        container.append(wrap);
                    }
                    secondPlaceholder.html(container.html()).addClass('open').show();
                }
            }

        } else {
            let menuItem = (menuRef === '.faculty-menu') ? menu[item] : studiesMenu[item];
            if (menuItem && menuItem.items.length > 0) {
                let container = $('<div/>')
                if (isTouch) {
                    container.append('\
                    <div class="option show-all-options ng-star-inserted"><a class="nav-link waves-light" href="/' + menuItem.url + '"><span class="tag">' + textAllAbout + ' ' +  menuItem.label + ' </span></a></div>');
                }
                for (let i in menuItem.items) {
                    let nextItem = menuItem.items[i];
                    container.append('\
                        <div class="option areas-option">\
                            <a class="nav-link areas-option-nav-link waves-light" ' + (isTouch ? '' : 'href="/' + nextItem.url + '"') + ' data-parent-item="' + item + '" data-item="' + i + '">\
                                <span class="tag">' + nextItem.label + '</span>'+ injectAngleRightIcon() +
                            '</a>\
                        </div>');
                }
                nextPlaceholder.html(container.html()).addClass('open')
                secondPlaceholder.removeClass('open').hide()
            }
        }

    } catch (e) {
        console.error("Faculty menu item [" + $.trim(elem.text()) + "] not found: " + e);
    }
}

export function bindMenuAnimations(){
    var techNavigation = $('#tech-navigation');

    techNavigation.on('mouseenter', '.faculty-menu a', {}, function(evt) {
        executeMenuAnimations($(evt.currentTarget), '.faculty-menu')
    })
    techNavigation.on('mouseenter', '.study-menu a', {}, function(evt) {
        executeMenuAnimations($(evt.currentTarget), '.study-menu')
    })
}

export function convertDesktopMenuToTouch() {
    //console.log('Switching desktop menu to touch mode')
    let techNavigation = $('#tech-navigation');
    let facultyMenuAnchor = $('.faculty-menu a');
    facultyMenuAnchor.removeAttr('href')

    techNavigation.on('click', '.faculty-menu a:not([href])', {}, function(evt) {
        executeMenuAnimations($(evt.currentTarget), '.faculty-menu')
    })
    techNavigation.on('click', '.study-menu a:not([href])', {}, function(evt) {
        executeMenuAnimations($(evt.currentTarget), '.study-menu')
    })
    techNavigation.off('mouseenter', '.faculty-menu a')
    techNavigation.off('mouseenter', '.study-menu a')
}